import { createOptions } from '../../common/rest/index.tsx';

const getUrl = (componentId: string): string => `/rest/api/2/component/${componentId}`;

export const deleteComponent = async (
	componentId: string,
	moveIssuesTo?: string,
): Promise<Response> => {
	const queryString = moveIssuesTo ? `?moveIssuesTo=${moveIssuesTo}` : '';
	const fullUrl = `${getUrl(componentId)}${queryString}`;
	return fetch(fullUrl, createOptions('DELETE'));
};

export const getComponentRelatedIssueCount = async (componentId: string): Promise<Response> => {
	const fullUrl = `${getUrl(componentId)}/relatedIssueCounts`;
	return fetch(fullUrl, createOptions('GET'));
};
